import VueRouter from 'vue-router'

import index from './components/index';
import news from './components/news/'
import newsDetail from './components/news/detail';
import introduct from './components/introduction/'
import stay from './components/stay/index';
import stayList from './components/stay/list';
import stayApply from './components/stay/apply/edit';
import assignRoom from './components/stay/assignRoom/index';
import intoRoomData from "./components/stay/intoroom/intoRoomData";
import intoRoom from "./components/stay/intoroom/index";
import timeSetting from "./components/stay/timeSetting/timeSetting";
import leaveApply from "./components/stay/leave/apply";
import leave from "./components/stay/leave";
import note from "./components/stay/leave/note";
import itemSetting from "./components/stay/leave/itemSetting/index";
import datePeriod from "./components/stay/leave/datePeriod";
import overnight from "./components/stay/overnight/index";
import overnightApply from "./components/stay/overnight/apply";
import mage from "./components/stay/mage/index";
import mageDetail from "./components/stay/mage/detail";
import borrow from "./components/stay/borrow/index"
import borrowApply from "./components/stay/borrow/apply";
import violate from "./components/stay/violate/index";
import violateEdit from "./components/stay/violate/edit";
import deduct from './components/stay/deduct/index';
import deductDetail from './components/stay/deduct/detail.vue';
import deductEdit from './components/stay/deduct/edit';
import revoke from './components/stay/revoke/index';
import revokeEdit from './components/stay/revoke/edit';
import rollcall from "./components/stay/rollcall/index";
import stayNews from "./components/stay/news/index";
import stayNewsDetail from "./components/stay/news/detail";
import environmentSettingClean from "./components/stay/environment/settingClean";
import environmentSettingCleanStaff from "./components/stay/environment/settingCleanStaff";
import environmentAudit from "./components/stay/environment/audit";
import technoDatabase from "./components/techno-database/index";
import tenancyOpinionback from './components/tenancy-opinionback/index';
import tenancyOpinionbackEdit from './components/tenancy-opinionback/edit';
import reliefApply from './components/assist/relief/apply/edit';
import relief from './components/assist/relief/index';
import reliefList from './components/assist/relief/list';
import reliefFee from './components/assist/relief/fee';
import reliefExport from './components/assist/relief/export';
import reliefReport from './components/assist/relief/report';
import reliefTimeSetting from './components/assist/relief/timeSetting';
import weakApply from './components/assist/weak/apply/edit';
import weak from './components/assist/weak/index';
import weakList from './components/assist/weak/list';
import weakFee from './components/assist/weak/fee';
import weakExport from './components/assist/weak/export';
import weakReport from './components/assist/weak/report';
import weakTimeSetting from './components/assist/weak/timeSetting';
import assistTreaty from './components/assist/treaty';


import authority from './components/authority/index';
import notFound from './components/notFound';

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err);
}
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

let pages = {
	'/budget-import': () => import('./bursary/views/budgetImport'),
	'/budget': () => import('./bursary/views/budget'),
	'/budget/total-work/:id': () => import('./bursary/views/budget/totalWork'),
	'/budget/used-work/:id': () => import('./bursary/views/budget/usedWork'),
	'/budget/total-study/:id': () => import('./bursary/views/budget/totalStudy'),
	'/budget/used-study/:id': () => import('./bursary/views/budget/usedStudy'),
	'/budget/increase/:id/:type': () => import('./bursary/views/budget/increase'),
	'/verification/audit': () => import('./bursary/views/verification/audit'),
	'/verification/backup': () => import('./bursary/views/verification/backup'),
	'/verification/export': () => import('./bursary/views/verification/export'),
	'/workstudy': () => import('./bursary/views/workstudy'),
	'/workstudy/create/:type': () => import('./bursary/views/workstudy/create'),
	'/workstudy/info/:id': () => import('./bursary/views/workstudy/info'),
	'/workstudy/studyRecord/:id': () => import('./bursary/views/workstudy/studyRecord'),
	'/workstudy/workRecord/:id': () => import('./bursary/views/workstudy/workRecord'),
	'/workstudy/schedule': () => import('./bursary/views/workstudy/schedule'),
	'/workstudy/schedule/:id': () => import('./bursary/views/workstudy/schedule'),
	'/workstudy/cost/:year/:month': () => import('./bursary/views/workstudy/cost'),
  '/workstudy/treaty': () => import('./bursary/views/student/treaty'),
  '/workstudy/life/list': () => import('./bursary/views/workstudy/life/list'),
  '/workstudy/life/apply': () => import('./bursary/views/workstudy/life/edit'),
  '/workstudy/life/edit': () => import('./bursary/views/workstudy/life/edit'),
  '/workstudy/life/timeSetting': () => import('./bursary/views/workstudy/life/timeSetting'),
  '/workstudy/life/treaty': () => import('./bursary/views/workstudy/life/treaty'),
	'/student': () => import('./bursary/views/student'),
	'/student/schedule': () => import('./bursary/views/student/schedule'),
	'/student/date-list/:date': () => import('./bursary/views/student/date-list'),
	'/student/service-feedback/:year/:month': () => import('./bursary/views/student/serviceFeedback'),
	'/student/work-record/:id': () => import('./bursary/views/student/workRecord'),
	'/student/leave/:id': () => import('./bursary/views/student/leave'),
	'/student/employ/:id': () => import('./bursary/views/student/employ'),
	'/student/resign/:id': () => import('./bursary/views/student/resign'),
	'/leave-audit': () => import('./bursary/views/leaveAudit'),
	'/leave-audit/check/:id': () => import('./bursary/views/leaveAudit/check'),
	'/keep-manage': () => import('./bursary/views/keep-manage'),
	'/tenancy-safety': () => import('./bursary/views/tenancy-safety'),
	'/tenancy-instructor': () => import('./bursary/views/tenancy-instructor'),
	'/tenancy-instructor/create': () => import('./bursary/views/tenancy-instructor/create'),
	'/tenancy-instructor/edit/:id': () => import('./bursary/views/tenancy-instructor/edit'),
	'/tenancy-register': () => import('./bursary/views/tenancy-register'),
  '/tenancy-register/treaty': () => import('./bursary/views/tenancy-register/treaty'),
	'/tenancy-register/edit/:year/:id': () => import('./bursary/views/tenancy-register/edit'),
	'/tenancy-visit': () => import('./bursary/views/tenancy-visit'),
	'/tenancy-visit/edit/:year/:id': () => import('./bursary/views/tenancy-visit/edit'),
	'/tenancy-statistic': () => import('./bursary/views/tenancy-statistic'),
	'/tenancy-mail': () => import('./bursary/views/tenancy-mail'),
	'/tenancy-news': () => import('./bursary/views/tenancy-news'),
	'/tenancy-news/detail': () => import('./bursary/views/tenancy-news/detail'),
	'/military/base': () => import('./bursary/views/military/base'),
	'/military/base/edit/:id': () => import('./bursary/views/military/base/edit'),
	'/military/student': () => import('./bursary/views/military/student'),
	'/military/apply': () => import('./bursary/views/military/apply'),
	'/military/setting': () => import('./bursary/views/military/setting'),
}

const routes =[{
	path: '/',
	name: "index",
	component: news,
}, {
	path: '/news',
	name: "news",
	component: news,
},{
	path: '/newsDetail',
	name: "newsDetail",
	component: newsDetail,
},{
	path: '/introduct',
	name: "introduct",
	component: introduct,
},{
	path: '/stay',
	component: stay,
	children: [{
		path: '',
		name: "stay.list",
		component: stayList,
	}, {
        path: '/stay/apply/treaty',
		name: "stay.apply.treaty.edit",
        component: () => import("./components/stay/apply/treaty.vue")
    },{
		path: '/stay/apply/new',
		name: "stay.apply.new",
		component: stayApply,
	},{
		path: '/stay/apply/view',
		name: "stay.apply.view",
		component: stayApply,
	},{
		path: '/stay/apply/edit',
		name: "stay.apply.edit",
		component: stayApply,
	}, {
		path: '/stay/timeSetting',
		name: "stay.timeSetting",
		component: timeSetting,
	}, {
		path: '/stay/assignRoom',
		name: "stay.assignRoom",
		component: assignRoom,
		props: true
	}, {
		path: '/stay/intoRoom',
		name: "stay.intoRoom",
		component: intoRoom,
	}, {
		path: '/stay/intoRoomData',
		name: "stay.intoRoomData",
		component: intoRoomData,
		props: true
	}, {
		path: '/stay/leave/apply',
		name: "stay.leave.apply",
		component: leaveApply,
		props: true
	}, {
		path: '/stay/leave',
		name: "stay.leave",
		component: leave,
	}, {
    path: '/stay/leave/note',
    name: "stay.leave.note",
    component: note,
    props: true
  }, {
    path: '/stay/leave/itemSetting',
    name: "stay.leave.itemSetting",
    component: itemSetting,
    props: true
  }, {
    path: '/stay/leave/datePeriod',
    name: "stay.leave.datePeriod",
    component: datePeriod,
  }, {
		path: '/stay/overnight',
		name: "stay.overnight",
		component: overnight
	},{
		path:'/stay/overnight/detail',
		name: "stay.overnight.detail",
		component: () => import("./components/stay/overnight/detail")
	}, {
		path: '/stay/overnight/apply',
		name: "stay.overnight.apply",
		component: overnightApply,
		props: true
	}, {
		path: '/stay/mage',
		name: "stay.mage",
		component: mage,
	}, {
		path: '/stay/mageDetail',
		name: "stay.mageDetail",
		component: mageDetail,
		props: true
	}, {
		path:"/stay/borrow",
		name:"stay.borrow",
		component:borrow,
	}, {
		path:"/borrow/apply",
		name:"stay.borrowApply",
		component:borrowApply,
	}, {
		path:"/stay/violate",
		name:"stay.violate",
		component:violate,
	}, {
		path:"/stay/violate/edit",
		name:"stay.violateEdit",
		component:violateEdit,
	}, {
		path:"/stay/deduct",
		name:"stay.deduct",
		component:deduct,
	}, {
		path:"/stay/deduct/detail",
		name:"stay.deduct.detail",
		component:deductDetail,
	}, {
		path:"/stay/deduct/edit",
		name:"stay.deduct.edit",
		component:deductEdit,
	}, {
		path:"/stay/revoke",
		name:"stay.revoke",
		component:revoke
	}, {
		path:"/stay/revoke/edit",
		name:"stay.revoke.edit",
		component:revokeEdit
	}, {
		path:"/stay/rollcall",
		name:"stay.rollcall",
		component:rollcall,
	}, {
		path:"/stay/news",
		name:"stay.news",
		component:stayNews,
	}, {
		path:"/stay/news/detail",
		name:"stay.news.detail",
		component:stayNewsDetail,
	}, {
		path:"/stay/environment/settingClean",
		name:"stay.environment.settingClean",
		component:environmentSettingClean,
	},{
		path:"/stay/environment/settingCleanStaff",
		name:"stay.environment.settingCleanStaff",
		component:environmentSettingCleanStaff,
	},{
		path:"/stay/environment/audit",
		name:"stay.environment.audit",
		component:environmentAudit,
	},{
		path:"/stay/menjin",
		name:"stay.menjin",
		component:() => import("./components/stay/menjin"),
	}]
},{
	path: '/assist/relief',
	component: relief,
	children: [{
		path: '',
		name: "relief.list",
		component: reliefList,
	},{
		path: '/assist/relief/edit',
		name: "relief.apply.edit",
		component: reliefApply,
	},{
		path: '/assist/relief/new',
		name: "relief.apply.new",
		component: reliefApply,
	},{
		path: '/assist/relief/fee',
		name: "relief.fee",
		component: reliefFee,
	},{
		path: '/assist/relief/export',
		name: "relief.export",
		component: reliefExport,
	},{
		path: '/assist/relief/report',
		name: "relief.report",
		component: reliefReport,
	},{
		path: '/assist/relief/setting',
		name: "relief.timeSetting",
		component: reliefTimeSetting,
	},{
    path: '/assist/relief/treaty',
    name: "relief.treaty",
    component: assistTreaty,
    props: true
  }]
},{
	path: '/assist/weak',
	component: weak,
	children: [{
		path: '',
		name: "weak.list",
		component: weakList,
	},{
		path: '/assist/weak/edit',
		name: "weak.apply.edit",
		component: weakApply,
	},{
		path: '/assist/weak/new',
		name: "weak.apply.new",
		component: weakApply,
	},{
		path: '/assist/weak/fee',
		name: "weak.fee",
		component: weakFee,
	},{
		path: '/assist/weak/export',
		name: "weak.export",
		component: weakExport,
	},{
		path: '/assist/weak/report',
		name: "weak.report",
		component: weakReport,
	},{
		path: '/assist/weak/setting',
		name: "weak.timeSetting",
		component: weakTimeSetting,
	},{
    path: '/assist/weak/setting',
    name: "weak.timeSetting",
    component: weakTimeSetting,
  },{
    path: '/assist/weak/treaty',
    name: "weak.treaty",
    component: assistTreaty,
    props: true
  }]
}, {
	path: "/technoDatabase",
	name: "technoDatabase",
	component: technoDatabase,
},{
	path: "/tenancyOpinionback",
	name: "tenancyOpinionback",
	component: tenancyOpinionback,
},{
	path: "/tenancyOpinionbackEdit",
	name: "tenancyOpinionbackEdit",
	component: tenancyOpinionbackEdit,
},{
	path: "/authority",
	name: "authority",
	component: authority,
}, {
	path: "/notFound",
	name: "notFound",
	component: notFound,
}, {
	path: '', redirect: '/'
}, {
	path: '/index', redirect: '/'
},{
    path: '*', redirect: '/notFound'
}];
Object.keys(pages).map(b => {
	routes.push({
		name: b,
		path: b,
		component: pages[b],
	})
})

export default new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});
